import Vue from 'vue'
import Router from 'vue-router'

import Logout from '../components/Logout.vue'
import Login from '../components/Login.vue'

import Profile from '../components/Profile.vue'

import fundsIndex from '../components/funds/Index.vue'
import fundsCreate from '../components/funds/Create.vue'
import fundsShow from '../components/funds/Show.vue'
import fundsSearch from '../components/funds/Search.vue'

import personsIndex from '../components/persons/Index.vue'
import personsCreate from '../components/persons/Create.vue'
import personsShow from '../components/persons/Show.vue'

import placesIndex from '../components/places/Index.vue'
import placesCreate from '../components/places/Create.vue'
import placesShow from '../components/places/Show.vue'

import keywordsIndex from '../components/keywords/Index.vue'
import keywordsCreate from '../components/keywords/Create.vue'
import keywordsShow from '../components/keywords/Show.vue'

import macrotagsIndex from '../components/macrotags/Index.vue'
import macrotagsCreate from '../components/macrotags/Create.vue'
import macrotagsShow from '../components/macrotags/Show.vue'

import microtagsIndex from '../components/microtags/Index.vue'
import microtagsCreate from '../components/microtags/Create.vue'
import microtagsShow from '../components/microtags/Show.vue'

import reelsShow from '../components/reels/Show.vue'
import reelsCreate from '../components/reels/Create.vue'
import reelsSearch from '../components/reels/Search.vue'

import sequencesShow from '../components/sequences/SequencesShow.vue'
import sequencesCreate from '../components/sequences/SequencesCreate.vue'

import collectionsIndex from '../components/collections/CollectionsIndex.vue'
import collectionsShow from '../components/collections/CollectionsShow.vue'
import collectionsCreate from '../components/collections/CollectionsCreate.vue'

import BaseComponent from '../components/layout/BaseComponent.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      name: 'baseComponent',
      component: BaseComponent,
      redirect: 'funds',
      children: [
        //
        // FUNDS
        {
          path: 'funds',
          name: 'fundsIndex',
          component: fundsIndex
        },
        {
          path: 'fund',
          name: 'fundsCreate',
          component: fundsCreate
        },
        {
          path: 'funds/:id',
          name: 'fundsShow',
          component: fundsShow
        },
        {
          path: 'funds-search',
          name: 'fundsSearch',
          component: fundsSearch
        },
        //
        // REELS
        {
          path: 'reel',
          name: 'reelsCreate',
          component: reelsCreate
        },
        {
          path: 'reels/:id',
          name: 'reelsShow',
          component: reelsShow
        },
        {
          path: 'reels-search',
          name: 'reelsSearch',
          component: reelsSearch
        },
        //
        // SEQUENCES
        {
          path: 'sequence',
          name: 'sequencesCreate',
          component: sequencesCreate
        },
        {
          path: 'sequences?id=:id&showMap=:showMap',
          name: 'sequencesShow',
          component: sequencesShow
        },
        //
        // PERSONS
        {
          path: 'persons',
          name: 'personsIndex',
          component: personsIndex
        },
        {
          path: 'person',
          name: 'personsCreate',
          component: personsCreate
        },
        {
          path: 'persons/:id',
          name: 'personsShow',
          component: personsShow
        },
        //
        // PLACES
        {
          path: 'places',
          name: 'placesIndex',
          component: placesIndex
        },
        {
          path: 'place',
          name: 'placesCreate',
          component: placesCreate
        },
        {
          path: 'places/:id',
          name: 'placesShow',
          component: placesShow
        },
        //
        // KEYWORDS
        {
          path: 'keywords',
          name: 'keywordsIndex',
          component: keywordsIndex
        },
        {
          path: 'keyword',
          name: 'keywordsCreate',
          component: keywordsCreate
        },
        {
          path: 'keywords/:id',
          name: 'keywordsShow',
          component: keywordsShow
        },
        //
        // MACROTAGS
        {
          path: 'macrotags',
          name: 'macrotagsIndex',
          component: macrotagsIndex
        },
        {
          path: 'macrotag',
          name: 'macrotagsCreate',
          component: macrotagsCreate
        },
        {
          path: 'macrotags/:id',
          name: 'macrotagsShow',
          component: macrotagsShow
        },
        //
        // MICROTAGS
        {
          path: 'microtags',
          name: 'microtagsIndex',
          component: microtagsIndex
        },
        {
          path: 'microtag',
          name: 'microtagsCreate',
          component: microtagsCreate
        },
        {
          path: 'microtags/:id',
          name: 'microtagsShow',
          component: microtagsShow
        },
        //
        // PROFILE
        {
          path: 'profile',
          name: 'profile',
          component: Profile
        },
        //
        // COLLECTIONS
        {
          path: 'collections',
          name: 'collectionsIndex',
          component: collectionsIndex
        },
        {
          path: 'collection',
          name: 'collectionsCreate',
          component: collectionsCreate
        },
        {
          path: 'collections/:id',
          name: 'collectionsShow',
          component: collectionsShow
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js